import Cookies from 'js-cookie'
const app = {
  state: {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh',
    size: Cookies.get('size') || 'mini',
    allDemand: window.sessionStorage.getItem('allDemand'),
    allTask: window.sessionStorage.getItem('allTask'),
    home: window.localStorage.getItem('home')
  },
  mutations: {
    SET_ALLDEMAN: (state, data) => {
      state.allDemand = data
      window.sessionStorage.setItem('allDemand', data)
    },
    REMOV_EDEMAN: () => {
      window.sessionStorage.removeItem('allDemand')
    },
    GET_ALLDEMAN: state => {
      window.sessionStorage.getItem('allDemand', state.allDemand)
    },

    SET_ALLTASK: (state, data) => {
      state.allTask = data
      window.sessionStorage.setItem('allTask', data)
    },
    REMOV_TASK: () => {
      window.sessionStorage.removeItem('allTask')
    },
    GET_ALLTASK: state => {
      window.sessionStorage.getItem('allTask', state.allTask)
    },

    SET_HOME: (state, data) => {
      state.home = data
      window.localStorage.setItem('home', data)
    },
    REMOV_HOME: () => {
      window.localStorage.removeItem('home')
    },
    GET_HOME: state => {
      window.localStorage.getItem('home', state.home)
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    }

  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
    setAllDemand({ commit }, data) {
      commit('SET_ALLDEMAN', data)
    },
    getAllDemand({ commit }) {
      commit('GET_ALLDEMAN')
    },
    removeDeman({ commit }) {
      commit('REMOV_EDEMAN')
    },

    setAllTask({ commit }, data) {
      commit('SET_ALLTASK', data)
    },
    removeTask({ commit }) {
      commit('REMOV_TASK')
    },
    getAllTask({ commit }) {
      commit('GET_ALLTASK')
    },

    setHome({ commit }, data) {
      commit('SET_HOME', data)
    },
    removeHome({ commit }) {
      commit('REMOV_HOME')
    },
    getHome({ commit }) {
      commit('GET_HOME')
    }
  }
}

export default app
